import ValidationModule from "~/entities/ValidationModule";

export default class Validation {
  public module!: ValidationModule; // polymorphic validation core

  public constructor(module: ValidationModule) {
    this.module = module;
  }

  public async Validate(scope: string = ""): Promise<any> {
    // trigger module specific validation
    this.module.validating = true;
    const validation = await this.module.Validate(scope);
    this.module.validating = false;
    return validation;
  }

  public isValid(): boolean {
    // asks module if validation completed
    return (
      this.module.validationMade &&
      this.module.validationErrors.length === 0 &&
      this.module.validated
    );
  }

  public isValidated(): boolean {
    return this.module.validated;
  }

  public isValidationMade(): boolean {
    return this.module.validationMade;
  }

  public hasValidationErrors(error: string = ""): any {
    if (error) {
      return this.module.validationErrors?.includes(error);
    }
    return this.module.validationErrors.length
      ? this.module.validationErrors
      : false;
  }

  public getModule(): ValidationModule {
    return this.module;
  }

  // in later versions, PLEASE set the module to private and define sets, getters and calls for only those functions needed
  // specially for those that access to the module's component to call the stores, as there's POSSIBILITY OF RECURSION.
  // It needs to restrict free access to prevent recursion like this theoretical example:
  // search.vue -> setError -> ValidationSearch -> ValidationSearch.component -> setError -> ValidationSearch -> ValidationSearch.component->...

  // Basically, prevent a component (or module) to call a function on the module (or component) that will result on an eventual call to itself.
  // Theoretically this would only happen if ValidationModule is badly inherit and made to access everything, but the structure should also
  // prevent this from happening, by having just a handset of methods with access to component from the validation class or the module,
  // there should be a caller traffic light that should prevent rogue calls to recursion loops like the one two lines above
}
